export default function () {
	return {
		badge_id: null,
		message_id: null,
		news_id: null
	}
}
